import React from 'react';
import './comp.css';
const Components = () => {
    return (
        <>
        <div class="iframe-container1">
        <b>
        <h2>Get Components</h2>
        </b>
        <p className='text1'>
        You can get all of your required components from Electronics Club by filling out the form given below.
        </p>
        
        <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScAD55IJr8rVdidT1UFYuFr6hlDUGzxv_7BvlwKnHJr3dZ5vQ/viewform?embedded=true" width="640" height="1217" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
        </div>
        </>
    );
};
export default Components;